/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.3.1 routes of Zorgmee::Application.
 * @version 56dcfda413806e0edd0bf11c2a880bbf1f0e7e6cab5b27ac4d5a5c4feca4eceb
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/addresses/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_address_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/addresses(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_addresses_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/calendars/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_calendar_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/calendars(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_calendars_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"calendars"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/consultations/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_consultation_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/consultation_prices/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_consultation_price_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_prices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/consultation_price_batch(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_consultation_price_batch_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_price_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/consultation_prices(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_consultation_prices_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_prices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/consultation_reminders/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_consultation_reminder_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_reminders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/consultation_reminders(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_consultation_reminders_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/consultation_types/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_consultation_type_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/consultation_types(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_consultation_types_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/consultations(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_consultations_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/contacts/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_contact_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/contacts(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_contacts_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/countries(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_countries_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/documents(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_documents_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/dossiers/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_dossier_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossiers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/dossier_items/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_dossier_item_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/dossier_items(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_dossier_items_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/dossiers(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_dossiers_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossiers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/email_communications(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_communications_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"email_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/email_templates/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_template_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"email_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/email_template_batch(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_template_batch_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"email_template_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/email_templates(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_templates_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"email_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/employments/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_employment_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"employments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/employments(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_employments_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"employments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/events/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_event_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/events(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_events_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/generate_consultation_errors/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_generate_consultation_error_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"generate_consultation_errors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/google_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_google_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"google_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/health_funds(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_health_funds_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"health_funds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/invoices/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_invoice_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/invoice_configurations/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_invoice_configuration_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoice_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/invoice_configurations(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_invoice_configurations_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoice_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/invoice_items/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_invoice_item_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoice_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/invoice_items(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_invoice_items_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoice_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/invoices(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_invoices_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/locations/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_location_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/locations(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_locations_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/match_proposals(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_match_proposals_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"match_proposals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/match_reviews(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_match_reviews_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"match_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/new_email_communications(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_new_email_communications_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"new_email_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/notifications/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_notification_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/notifications(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_notifications_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/offices/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_office_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"offices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/offices(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_offices_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"offices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/organisations/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organisation_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/organisations(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organisations_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/outlook_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_outlook_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"outlook_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/pings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_pings_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"pings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/relationships/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_relationship_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"relationships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/relationships(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_relationships_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"relationships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/remove_consultation_errors/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_remove_consultation_error_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"remove_consultation_errors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/resources(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_resources_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/search_results(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_search_results_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"search_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/selectable_calendars(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_selectable_calendars_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"selectable_calendars"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/teams(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_teams_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/templates/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_template_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/templates(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_templates_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/todos/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_todo_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"todos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/todos(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_todos_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/users/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/documents/:id/attachment(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_api_document_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/dossier_items/:id/attachment(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_api_dossier_item_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/calendars/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/calendars(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendars_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"calendars"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/subscriptions/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_superuser_api_billing_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/compass(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compass_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"compass"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compasses_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/configuration(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configuration_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultations/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consultation_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultation_prices/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consultation_price_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_prices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultation_prices(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consultation_prices_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_prices"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultation_reminders/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consultation_reminder_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_reminders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultation_reminders(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consultation_reminders_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultations(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consultations_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/contacts/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/contacts(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contacts_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/invoices/:id/credit_note(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credit_note_superuser_api_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"credit_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/documents(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const documents_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossiers/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dossier_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossiers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossier_financials/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dossier_financial_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_financials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossier_financials(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dossier_financials_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_financials"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossier_infos/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dossier_info_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossier_infos(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dossier_infos_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossiers(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dossiers_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossiers"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/documents/:id/download(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_api_document_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/dossier_items/:id/download(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_api_dossier_item_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/invoices/:id/download_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_pdf_superuser_api_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/calendars/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_calendar_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/events/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_event_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/calendars/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_calendar_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/compass/edit(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_compass_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"compass"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/configuration/edit(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_configuration_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultations/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_consultation_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultation_prices/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_consultation_price_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_prices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultation_reminders/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_consultation_reminder_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_reminders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/contacts/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_contact_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/documents/edit(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_documents_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossiers/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dossier_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossier_financials/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dossier_financial_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_financials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossier_infos/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dossier_info_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/employments/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_employment_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"employments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/invoices/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_invoice_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/invoice_configurations/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_invoice_configuration_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoice_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/locations/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_location_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/notifications/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_notification_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/organisations/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organisation_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/receipts_journal/edit(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_receipts_journal_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"receipts_journal"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/invoices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_superuser_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/runs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_superuser_billing_run_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_superuser_billing_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/supplier_config/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_superuser_billing_supplier_config_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"supplier_config"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/health_funds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_superuser_health_fund_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"health_funds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/offices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_superuser_office_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"offices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_superuser_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/templates/:id/edit(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_template_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossiers/:id/editor(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editor_dossier_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/employments/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employment_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"employments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/employments(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const employments_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"employments"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/dossiers/:id/export(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_api_dossier_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/invoices/generate_proposal(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_proposal_api_invoices_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"generate_proposal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/invoices/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/invoice_configurations/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_configuration_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoice_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/invoice_configurations(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_configurations_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoice_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/invoices(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoices_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/locations/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const location_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/locations(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locations_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/locations/:id/logo(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logo_api_location_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/invoices/:id/mark_paid(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_paid_superuser_api_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/dossiers/:id/merge_dossiers(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const merge_dossiers_api_dossier_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge_dossiers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/calendars/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_calendar_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/email_communications/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_email_communication_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"email_communications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/events/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_event_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/calendars/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_calendar_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/compass/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_compass_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"compass"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/configuration/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_configuration_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultations/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_consultation_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultation_prices/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_consultation_price_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_prices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/consultation_reminders/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_consultation_reminder_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"consultation_reminders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/contacts/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_contact_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/documents/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_documents_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossiers/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dossier_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossiers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossier_financials/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dossier_financial_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_financials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/dossier_infos/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dossier_info_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"dossier_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/employments/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_employment_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"employments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/invoices/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_invoice_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/invoice_configurations/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_invoice_configuration_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoice_configurations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/locations/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_location_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/notifications/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_notification_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/organisations/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organisation_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/receipts_journal/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_receipts_journal_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"receipts_journal"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/invoices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_superuser_billing_invoice_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/runs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_superuser_billing_run_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_superuser_billing_subscription_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/supplier_config/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_superuser_billing_supplier_config_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"supplier_config"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/health_funds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_superuser_health_fund_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"health_funds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/offices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_superuser_office_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"offices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_superuser_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/templates/new(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_template_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/notifications/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/notifications(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/organisations/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/organisations(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisations_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/subscriptions/:id/pause(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_superuser_api_billing_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/subscriptions/:id/preview_invoice(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_invoice_superuser_api_billing_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/receipts_journal(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receipts_journal_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"receipts_journal"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/calendars/request_sync(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_sync_api_calendars_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[6,"request_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/subscriptions/:id/resume(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resume_superuser_api_billing_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/invoices/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_superuser_api_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/invoices/:id/send_on_peppol(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_on_peppol_api_invoice_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_on_peppol"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/invoices/:id/send_peppol(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_peppol_superuser_api_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_peppol"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const session_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/employments/:id/signature(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_api_employment_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"employments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"signature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/invoices/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_superuser_api_billing_invoices_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_billing_invoices_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_billing_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_billing_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_billing_runs_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_billing_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_billing_subscriptions_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/supplier_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_billing_supplier_config_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"supplier_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_countries_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/employments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_employments_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"employments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/health_funds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_health_fund_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"health_funds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/health_funds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_health_funds_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"health_funds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/offices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_office_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/offices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_offices_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"offices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_api_resources_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_billing_invoices_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/runs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_billing_run_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_billing_runs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_billing_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_billing_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/billing/supplier_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_billing_supplier_config_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"supplier_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/health_funds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_health_fund_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"health_funds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/health_funds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_health_funds_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"health_funds"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /superuser/offices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_office_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"offices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/offices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_offices_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"offices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /superuser(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_offices_idx_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /superuser/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_sidekiq_web_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[6,"sidekiq"]]]]);

/**
 * Generates rails route to
 * /superuser/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const superuser_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/templates/:id(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:office_slug(/:view)/templates(.:format)
 * @param {any} office_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const templates_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"format":{}}, [2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api/:office_slug(/:view)/invoices/:id/toggle_payed(.:format)
 * @param {any} office_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_payed_api_invoice_path = /*#__PURE__*/ __route({"office_slug":{"r":true},"view":{},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"office_slug"],[2,[1,[2,[7,"/"],[3,"view"]]],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_payed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/runs/trigger(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trigger_superuser_api_billing_runs_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[6,"trigger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /superuser/api/billing/invoices/:id/unmark_paid(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unmark_paid_superuser_api_billing_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"superuser"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unmark_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/azure_activedirectory_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_azure_activedirectory_v2_omniauth_authorize_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"azure_activedirectory_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/azure_activedirectory_v2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_azure_activedirectory_v2_omniauth_callback_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"azure_activedirectory_v2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_authorize_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_callback_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_path = /*#__PURE__*/ __route({}, [7,"/"]);

